<template>
  <div class="container-dark" id="team">
    <div class="container">
      <h2 class="headline-light bebas">Das Team</h2>
      <div class="team-images">
        <img
          src="../assets/team/Team_links.jpg"
          width="50%"
          height="50%"
        />
        <img
          width="50%"
          height="50%"
          src="../assets/team/Team_mitte.jpg"
        />
        <img
          width="50%"
          height="50%"
          src="../assets/team/Team_rechts.jpg"
        />
      </div>
      <h2 class="headline-light bebas">Die Supporter</h2>
      <div class="team-images">
        <img
          src="../assets/supporter/support-links.jpg"
          width="50%"
          height="50%"
        />
        <img
          width="50%"
          height="50%"
          src="../assets/supporter/support-mitte.jpg"
        />
        <img
          width="50%"
          height="50%"
          src="../assets/supporter/support-rechts.jpg"
        />
      </div>
      <h2 class="headline-light bebas">Das Studio</h2>
      <div class="studio-images">
        <img
          src="../assets/studio/1Reihe_1.jpg"
        />
        <img
          src="../assets/studio/1Reihe_2.jpg"
        />
        <img
          src="../assets/studio/1Reihe_3.jpg"
        />
        <img
          src="../assets/studio/1Reihe_4.jpg"
        />
        <img
          src="../assets/studio/2Reihe_1.jpg"
        />
        <img
          src="../assets/studio/2Reihe_2.jpg"
        />
        <img
          src="../assets/studio/2Reihe_3.jpg"
        />
        <img
          src="../assets/studio/2Reihe_4.jpg"
        />
      </div>
      <h2 class="subtitle-light mt-6 bebas">Wie ist die Idee entstanden</h2>
      <p class="text-light">
        Die Idee zum Podcast entstand durch die zwangsbedingte Lage aufgrund der
        Corona-Pandemie, dass wir unserem liebsten Hobby, dem aktiven Spielen
        und Gucken im Amateur-Fußball, leider nicht mehr nachgehen konnten. Der
        Kontakt zu Mitspielern, Trainer und Verantwortlichen wurde von Tag zu
        Tag immer weniger und man bekam auch nichts mehr aus den anderen
        Vereinen mit. Vielleicht gibt es in dem ein oder anderen Verein ein Zoom
        Training, Training auf Abstand oder vielleicht Aktionen die Vereine
        aktuell begleiten?! Somit kamen wir, Kevin Lux und Oliver Kottwitz,
        eines Tages im Ladenlokal von stickerfive zusammen und philosophierten
        über die aktuelle Lage. Wir haben über Fußball gesprochen und dem
        dazugehörigen Quatsch. Schnell war uns klar, dass was wir besprechen,
        müssen wir in einem Podcast aufnehmen. Der Name war schnell gefunden
        ‘’KICK AND QUATSCH’’, eine Abwandlung von „Kick and Rush”. Frei raus,
        ungeschnitten und echt - so wollen wir den Podcast gestalten. Nach 3 ½ Jahren gab es eine kleine Änderung: Unser Supporter und Mitgestalter des Podcast Daniel Hölzel ist in die erste Reihe gerückt und führt seit Mitte 2024 den Podcast mit Kevin Lux.
      </p>
      <h2 class="subtitle-light bebas">UNSER TEAM, UNSERE SUPPORTER</h2>
      <p class="text-light">
        Alleine kann man den Aufwand die Leidenschaft für den Podcast nicht mehr betreiben. Somit dürfen wir ganz stolz unser Team hinter den Mikros vorstellen. Gerade bei unseren Veranstaltungen ist unser Team nicht mehr wegzudenken. Schön dass ihr den Weg mit uns geht und auch hier nochmal einen ganz großen Dank für jede Sekunde, Minute, Stunden, Tage die ihr an unserer Seite steht: Karim, Addi, Adrian, Pia, Kathi und Willy.
      </p>
      <h2 class="subtitle-light bebas">Ziel des Podcasts</h2>
      <p class="text-light">
        Wir möchten mit unseren Gästen hinter die Kulissen blicken, über deren
        Tätigkeit sprechen und Einblick in den Verein erhalten. Wir möchten
        unseren Hörern einen lockeren Fußball-Plausch präsentieren, der den Kick
        in den Vordergrund stellt. Der Quatsch darf natürlich nicht fehlen und
        ist ein fester Bestandteil unseres Podcasts. Wir danken allen Hörern für die zahlreichen Nachrichten und positiven Rückmeldungen nach jeder Folge. Unsere Folgen sind so aufgebaut, dass jeder Hörer den Podcast auch ohne großen Vorkenntnisse zur eingeladenen Person oder den Verein, sich den Podcast anhören kann.
      </p>
      <h2 class="subtitle-light bebas">FÜR DEN GUTEN ZWECK</h2>
      <p class="text-light">
        Die Kick and Quatsch Community kann viel bewegen. Wir spenden jährlich an das Sternenzelt e.V. Oberhausen und an den Hand in Hand Cup. Am Ende jeder Folge werden immer unsere beliebten Oder-Fragen gestellt. Bei jedem Oder, wenn der Gast sich nicht für eine Auswahl der beiden Antwortmöglichkeiten entscheiden kann, wandern 5 € in unser Sparschwein den Jürgen-Raimund. Wir sind dankbar für jeden Cent, den wir gemeinsam mit Euch, spenden können. Besonders muss man unseren Partner running4charity erwähnen. Mit Jörg Marquardt haben wir einen Pusher in unseren Reihen, der nicht nur den Fußball, Sport und unseren Podcast liebt, sondern unsere gespendeten Beiträge automatisch verdoppelt. Vielen Dank!
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>

<style lang="scss" scoped>

.container {
  .headline-light {
    text-align: center;
  }
}
</style>
